export declare interface Repayment {
  id?: string
  x365_account_iban?: string
  x365_split?: number | string
  balance?: number | string
  beneficiary_account_number?: string | null
  beneficiary_sort_code?: string | null
  card_transactions?: number | string
  cash_advance_id?: string
  cash_advance_allocation_failed?: boolean | string
  comments?: string
  repayment_date?: string
  description?: string
  merchant_id?: string
  new_balance?: number | string
  payment_amount?: number | string
  previous_balance?: number | string
  terminal_id?: string
  terminal_name?: string | null
  terminals?: {
    name: string
    id: string
  }
  merchants?: {
    name: string
    id: string
  }
  cash_advances?: {
    name: string
    id: string
    active_cash_advance?: boolean | null
  }
  uuid?: string
  source_file?: string
  last_changed_in?: string
  updated_by?: string
  row_number?: number | string
  // amount?: number | string
  deleted?: boolean
  staged?: boolean
  isNew?: boolean
  country?: string
  data_source?: PaymentProvider | string
  bank_account_id?: string
  outcome?: string
  month_of_repayment_txt?: string
  repayment_month?: string
  week_of_repayment?: string
  repayment_week_date?: string
  generated_from_repayment_id?: string
  changed?: boolean | string
  timestamp?: string
  last_sf_timestamp?: string
  created_date?: string
  created_date_time?: string
}

export enum PaymentProvider {
  APS = 'APS',
  CARDNET = 'Cardnet',
  CARDONE = 'CardOne',
  FDMS = 'FDMS',
  GOCARDLESS = 'Gocardless',
  DOJO_DIRECT_SPLIT = 'Dojo (Direct Split)',
  MODULR = 'Modulr',
  CUSTOM = 'Custom',
}

export type Repayments = Array<Repayment>
